import React from 'react';
import PropTypes from 'prop-types';
import { animated } from '@react-spring/web';
import classNames from 'classnames';

export const SubTray = (props) => {
  const { transitionStyles, children, trayTitle, setActiveTray } = props;

  return (<div className={classNames('mobile-sub-tray', 'absolute', 'full-width')}>
    <animated.div style={transitionStyles} className="full-width">
      <div
        className={classNames(
          'sub-tray-header',
          'flex middle'
        )}
      >
        <button
          className={classNames(
            'sub-tray-button btn-clear',
            'responsive-padding',
            'text-gray-900 h4'
          )}
          onClick={(e) => {
            e.preventDefault();
            setActiveTray('main');
          }}
        >
          <i
            className='icon-image-arrows'
            style={{ fontSize: '18px', marginRight: '0.5rem' }}
          />
          {trayTitle}
        </button>
      </div>
      <div>{children}</div>
    </animated.div>
  </div>);
};

SubTray.propTypes = {
  transitionStyles: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  trayTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  setActiveTray: PropTypes.func
};
